import { render, staticRenderFns } from "./ObjectsLayer.vue?vue&type=template&id=106f01d7"
import script from "./ObjectsLayer.vue?vue&type=script&lang=js"
export * from "./ObjectsLayer.vue?vue&type=script&lang=js"
import style0 from "./ObjectsLayer.vue?vue&type=style&index=0&id=106f01d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports